// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__7zu+U","div":"styles_div__jurB5","payout":"styles_payout__YWXWj"};